"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = void 0;
const stdlib_core_1 = require("@groupby/stdlib-core");
const array_1 = require("@groupby/stdlib-core/collections/array");
const constants_1 = require("./constants");
const sort_direction_1 = require("./sort-direction");
function parse(formattedList) {
    const normalizedList = normalizeFormattedList(formattedList);
    const parameters = normalizedList.map(parseParameter);
    if (array_1.someDuplicates(parameters, (a, b) => (a.propertyName === b.propertyName ? 0 : 1))) {
        throw new stdlib_core_1.IllegalArgumentException('Sort list may not contain a duplicate parameter.');
    }
    return parameters;
}
exports.parse = parse;
function normalizeFormattedList(formattedList) {
    const splitList = formattedList.split(constants_1.recordSeparator).map((e) => e.trim());
    if (splitList.length === 1 && splitList[0] === '') {
        return [];
    }
    if (splitList.includes('')) {
        throw new stdlib_core_1.IllegalArgumentException('Sort list may not contain an empty parameter.');
    }
    return splitList;
}
function parseParameter(formattedParameter) {
    const { name, direction } = normalizeFormattedParameter(formattedParameter);
    return { propertyName: name, direction: parseDirection(direction) };
}
function normalizeFormattedParameter(formattedParameter) {
    const splitParameter = formattedParameter.split(constants_1.unitSeparator).map((e) => e.trim());
    if (splitParameter.length < 1 || splitParameter.length > 2 || splitParameter[0] === '' || splitParameter[1] === '') {
        throw new stdlib_core_1.IllegalArgumentException(`Malformed parameter '${formattedParameter}'`);
    }
    return { name: splitParameter[0], direction: splitParameter[1] === undefined ? 'asc' : splitParameter[1] };
}
function parseDirection(direction) {
    switch (direction) {
        case 'asc':
            return sort_direction_1.SortDirection.Ascending;
        case 'desc':
            return sort_direction_1.SortDirection.Descending;
        default:
            throw new stdlib_core_1.IllegalArgumentException(`Unsupported sort direction '${direction}'`);
    }
}
//# sourceMappingURL=parse.js.map